module.exports = __webpack_public_path__ + "img/logo_ico.bdafd2e3.svg";